'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Layout from 'Layouts/Back';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Switch from 'Components/Forms/Elements/Switch';
import StatsBlock from 'Components/Blocks/DiscountCodesStatsBlock';
import request from 'Functions/ajax/request';
import { num, formatNum, capitalize } from 'Shared/utilities';
import { action } from 'Shared/Routes';
import Loader from 'Pure/Loader';
const {
  moment
} = window;
const cards = [{
  title: 'Nombre d\'utilisations',
  field: 'total_uses',
  format: '0,0'
}, {
  title: 'Montant total remisé',
  field: 'total_discounted',
  suffix: '€'
}, {
  title: 'Moyenne remisé par panier',
  field: 'average_cart_discounted',
  suffix: '€'
}, {
  title: 'Heures offertes',
  field: 'offered_hours'
}, {
  title: '% d\'heures offertes<br />(paniers avec code)',
  field: 'hours_ratio',
  suffix: '%'
}];
function getDefaultState() {
  const state = {
    start_date: '',
    end_date: '',
    global_stats: true,
    super_admin: window.location.pathname.startsWith('/super-admin-indicateurs/'),
    status_messages: {}
  };
  if (state.super_admin) {
    state.start_date = moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD');
  }
  return state;
}
export default class DiscountCodesIndicatorPage extends Component {
  state = {
    ...getDefaultState.bind(this)(),
    loading: true,
    series: [{
      name: '',
      data: Array.from({
        length: 12
      }).map((_v, i) => 0)
    }],
    options: {
      fill: {
        colors: ['#003768']
      },
      chart: {
        height: 390,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top' // top, center, bottom
          }
        }
      },

      dataLabels: {
        enabled: true,
        formatter: value => value > 0 ? formatNum(value, '0,0') : '',
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#003768']
        }
      },
      xaxis: {
        categories: Array.from({
          length: 12
        }).map(function (_v, i) {
          return capitalize(moment().startOf('year').add(i, 'months').format('MMMM'));
        }),
        position: 'top',
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: false
        },
        labels:
        // janvier, février, etc
        {
          offsetY: -5,
          show: true
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#003768',
              colorTo: '#003768',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: false,
          offsetY: 0
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          formatter: value => num(value, '0,0') + ' utilisations'
        },
        tooltip: {
          enabled: false
        },
        crosshairs: {
          show: false
        }
      },
      title: {
        text: 'Nombre de codes utilisés par mois',
        floating: true,
        offsetY: 330,
        align: 'center',
        style: {
          color: '#003768'
        }
      }
    }
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchStats({});
  }
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    if (e !== null)
      // did mount
      {
        component.fetchStats({
          filters: {
            [name]: value
          }
        });
      }
  };
  fetchStats = async ({
    filters = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const params = {};
    ['start_date', 'end_date', 'super_admin', 'global_stats'].forEach(function (field) {
      params[field] = typeof filters[field] === 'undefined' ? state[field] : filters[field];
    });
    try {
      var response = await request(action('DiscountCodesStats')).config({}).post(params);
    } catch (update) {
      return component.setState(update);
    }
    const {
      serie,
      ...update
    } = response;
    if (Array.isArray(serie) && serie.length === state.series[0].data.length) {
      state.series[0].data = serie;
      state.options.yaxis.max = serie.reduce(function (max, val) {
        return max + num(val, 0);
      }, 0) + 2;
    }
    component.setState({
      ...update,
      loading: false
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const stat_loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const stats = cards.map(function ({
      title,
      field,
      suffix,
      format
    }) {
      const rendered_title = title.split('<br />').map(function (text, i) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: text + '##i'
        }, i > 0 ? /*#__PURE__*/React.createElement("br", null) : undefined, text);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item",
        key: field
      }, /*#__PURE__*/React.createElement("h3", {
        className: "c-stats__item-title"
      }, rendered_title), /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item-result"
      }, formatNum(state[field], format || '0,0[.]00'), suffix), stat_loader);
    });
    return /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Indicateurs codes promo"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start_date'] || '',
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de d\xE9but",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end_date'] || '',
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de fin",
      "allow-no-value": true,
      status: state.status_messages
    })), state.super_admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleFilterChange,
      value: state.global_stats,
      name: "global_stats",
      label: "Afficher les stats globales",
      status: state.status_messages
    })) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats"
    }, stats)), stat_loader ? /*#__PURE__*/React.createElement("div", {
      className: "c-paper",
      style: {
        height: 380,
        position: 'relative',
        width: '100%',
        overflow: 'hidden'
      }
    }, stat_loader) : /*#__PURE__*/React.createElement(StatsBlock, {
      options: state.options,
      series: state.series
    })));
  }
}
